module.exports = __webpack_public_path__ + "files/6fa1ea016a1a7450c35abc50f150d532.png";